<template>
  <div class="courseInfo">
    <div
      class="ql-editor"
      v-if="list"
      v-html="list"
    ></div>
    <!-- <template v-else>
      <img
        src="../assets/course/teacherinfo.png"
        alt=""
      >
      <p class="inp">暂无课程简介</p>
    </template> -->
    <div class="notbox"  v-else>
      <img
        src="../assets/blank/notinfo.png"
        alt=""
      >
      <p class="inp">暂无课程简介</p>
    </div>
  </div>
</template>

<script>
// import Base64 from '@/units/base64.js'
import { getcourseDetailApi } from "@/request/api";
export default {
  name: "courseInfo",
  data() {
    return {
      courseId: "",
      list: null,
      Id: "",
    };
  },
  created() {
    this.widthClass = this.$route.query.widthClass;
    this.Id=JSON.parse(this.$Base64.decode(this.$route.query.id))
    // this.Id = this.$route.query.id;
    this.init();
  },
  methods: {
    init() {
      // console.log(this.Id)
      this.getToken(getcourseDetailApi, { courseId: this.Id }, (res) => {
        this.list = res.data.courseInfo;
        // console.log(res.data)
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.courseInfo {
  text-align: center;

  .notbox{
    margin:0 auto;
    margin-bottom:40px;
    margin-top:30px;
    text-align center;
    img {
      display:block
      margin:0 auto;
    }
  .inp {
      font-size: 18px;
      color: #666;
      margin: 0 auto;
      text-align: center;
      margin-top: 10px;
    }
  }
}
</style>
